export default __webpack_public_path__ + "static/media/ar-g.417b1454.svg";